import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	onboardingStateGetOnboardingStateQuery,
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from '@confluence/onboarding-helpers/entry-points/onboardingStateGetOnboardingStateQuery.ts';
import {
	NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS,
	ONBOARDING_EXPERIENCES,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import type { GraphQLError } from 'graphql';

export const preloadNthUserHomeOnboardingRevampState = (): Promise<{
	data: onboardingStateGetOnboardingStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS),
			],
		},
	});
};
